/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section links_list_js
	 ********************************************/
	(function ProductNavTabsModule() {
		var $tabModules;
		var $detailsModule;
		var $featuresBenefitsModule;
		var $fitmentModule;
		var $recommendedModule;
		var $reviewsModule;
		var $questionsModule;
		var $warrantyModule;
		var $interchangeModule;
		var $installationModule;
		var $policiesModule;
		var $additionalInfoModule;
		var $details;
		var $featuresBenefits;
		var $fitment;
		var $recommended;
		var $reviews;
		var $questions;
		var $warranty;
		var $interchange;
		var $installation;
		var $policies;
		var $additionalInfo;
		var $allTabs;
		var displaySingleTabs;
		var detailsOffset;
		var featuresBenefitsOffset;
		var fitmentOffset;
		var recommendedOffset;
		var reviewsOffset;
		var questionsOffset;
		var warrantyOffset;
		var interchangeOffset;
		var installationOffset;
		var policiesOffset;
		var additionalInfoOffset;
		var $detailsParent;
		/********************************************
		.* Attach
		.* -----------------------------------------
		.* Attach events to each module instance
		.********************************************/
		function attachEvents() {
			$tabModules = rp$('.product-tab-nav-module');
			displaySingleTabs = $tabModules.hasClass('display-single-tab');
			rp$.each($tabModules, function DropDownMenu_Iterator(idx, tabModule) {
				var $tabModule = rp$(tabModule);
				$detailsParent = $tabModule;

				// Check for Reviews
				// We'll do the same kind of check for reviews as we did for Recommended Parts

				// Check for the existence of modules on the page.
				if($detailsModule.length >= 1) {
					$details.css('display', 'inline-block');
					detailsOffset = $detailsModule.offset().top;
				}
				if($featuresBenefitsModule.length >= 1) {
					$featuresBenefits.css('display', 'inline-block');
					featuresBenefitsOffset = $featuresBenefitsModule.offset().top;
				}
				if($fitmentModule.length >= 1) {
					$fitment.css('display', 'inline-block');
					fitmentOffset = $fitmentModule.offset().top;
				}
				if($reviewsModule.length >= 1) {
					$reviews.css('display', 'inline-block');
					reviewsOffset = $reviewsModule.offset().top;
				}
				if($recommendedModule.length >= 1) {
					sectionHeading = $recommendedModule.find('.product-section-title').text();
					$recommended.text(sectionHeading);
					$recommended.css('display', 'inline-block');
					recommendedOffset = $recommendedModule.offset().top;
				}
				if($questionsModule.length >= 1) {
					$questions.css('display', 'inline-block');
					questionsOffset = $questionsModule.offset().top;
				}
				if($warrantyModule.length >= 1) {
					$warranty.css('display', 'inline-block');
					warrantyOffset = $warrantyModule.offset().top;
				}
				if($interchangeModule.length >= 1) {
					$interchange.css('display', 'inline-block');
					interchangeOffset = $interchangeModule.offset().top;
				}
				if ($installationModule.length >= 1) {
					$installation.css('display', 'inline-block');
					installationOffset = $installationModule.offset().top;
				}
				if ($additionalInfoModule.length >= 1) {
					$additionalInfo.css('display', 'inline-block');
					additionalInfoOffset = $additionalInfoModule.offset().top;
				}
				if ($policiesModule.length >= 1) {
					$policies.css('display', 'inline-block');
					policiesOffset = $policiesModule.offset().top;
				}

				if (displaySingleTabs) {
					removeSectionTitles();
					showModule();
				}
			});
		}

		/*
		 * This updates the focus to the selected tab so that when navigating via keyboard, the next keyboard Tab
		 * moves control to first element in selected tab.
		 */
		function passFocusToTab($selectedTab) {
			setTimeout(() => {
				$selectedTab.focus();
			}, 500);
		}

		function removeSectionTitles() {
			rp$('.product-section-title').remove();
		}

		function showModule($selectedTab) {
			if (!displaySingleTabs) {
				return;
			}
			const modules = [
				$detailsModule,
				$featuresBenefitsModule,
				$fitmentModule,
				$recommendedModule,
				$reviewsModule,
				$questionsModule,
				$warrantyModule,
				$interchangeModule,
				$installationModule,
				$additionalInfoModule
			];

			$selectedTab = $selectedTab || $detailsModule;

			modules.forEach(tabModule => {
				if (tabModule && tabModule != $selectedTab) {
					tabModule.hide();
				}
			});

			$selectedTab.show();
		}

		function highlightTitle(moduleTitle) {
			var $moduleTitle = moduleTitle;
			rp$('.product-section-title').removeClass('tab-selected');
			$moduleTitle.find('.product-section-title').addClass('tab-selected');
		}

		// Note: sectionOffset-60 accounts for fixed headers.
		function scrollToSection(selector, sectionOffset) {
			if(!displaySingleTabs) {
				rp$('html, body').animate({scrollTop: sectionOffset-60}, 500);
			}
			$allTabs.removeClass('tab-active');
			rp$(selector).addClass('tab-active');
		}

		$onReady({
			rp$, window,
			label: 'product_tab_nav',
			fn: function () {
				$detailsModule = rp$('.product-details-module');
				$featuresBenefitsModule = rp$('.col-md-12 .product-features-benefits-module');
				$fitmentModule = rp$('.product-fitment-module');
				$recommendedModule = rp$('.product-recommended-module');
				$reviewsModule = rp$('.product-reviews-module');
				$questionsModule = rp$('.product-questions-module');
				$warrantyModule = rp$('.product-warranty-module');
				$interchangeModule = rp$('.product-interchange-module');
				$installationModule = rp$('.product-installation-module');
				$policiesModule = rp$('.product-policies-module');
				$additionalInfoModule = rp$('.product-additional-info-module');
				$details = rp$('.product-details-button');
				$featuresBenefits = rp$('.product-features-benefits-button');
				$fitment = rp$('.product-fitment-button');
				$recommended = rp$('.product-also-purchased-button');
				$reviews = rp$('.product-reviews-button');
				$questions = rp$('.product-questions-button');
				$warranty = rp$('.product-warranty-button');
				$interchange = rp$('.product-interchange-button');
				$installation = rp$('.product-installation-button');
				$policies = rp$('.product-policies-button');
				$additionalInfo = rp$('.product-additional-info-button');
				$allTabs = rp$('.tab-nav');

				attachEvents();
				// Tab Functions & Scroll to functions
				$details.on('click', function(){
					scrollToSection(this, detailsOffset);
					highlightTitle($detailsParent); // Target Tab Heading on Desktop
					showModule($detailsModule);
					passFocusToTab($detailsModule);
				});
				$featuresBenefits.on('click', function(){
					scrollToSection(this, featuresBenefitsOffset);
					highlightTitle($featuresBenefitsModule);
					showModule($featuresBenefitsModule);
					passFocusToTab($featuresBenefitsModule);
				});
				$fitment.on('click', function(){
					scrollToSection(this, fitmentOffset);
					highlightTitle($fitmentModule);
					showModule($fitmentModule);
					passFocusToTab($fitmentModule);
				});
				$recommended.on('click', function(){
					scrollToSection(this, recommendedOffset);
					highlightTitle($recommendedModule);
					showModule($recommendedModule);
					passFocusToTab($recommendedModule);
				});
				$reviews.on('click', function(){
					scrollToSection(this, reviewsOffset);
					highlightTitle($reviewsModule);
					showModule($reviewsModule);
					passFocusToTab($reviewsModule);
				});
				$questions.on('click', function(){
					scrollToSection(this, questionsOffset);
					highlightTitle($questionsModule);
					showModule($questionsModule);
					passFocusToTab($questionsModule);
				});
				$warranty.on('click', function () {
					scrollToSection(this, warrantyOffset);
					highlightTitle($warrantyModule);
					showModule($warrantyModule);
					passFocusToTab($warrantyModule);
				});
				$interchange.on('click', function () {
					scrollToSection(this, interchangeOffset);
					highlightTitle($interchangeModule);
					showModule($interchangeModule);
					passFocusToTab($interchangeModule);
				});
				$installation.on('click', function () {
					scrollToSection(this, installationOffset);
					highlightTitle($installationModule);
					showModule($installationModule);
					passFocusToTab($installationModule);
				});
				$additionalInfo.on('click', function () {
					scrollToSection(this, additionalInfoOffset);
					highlightTitle($additionalInfoModule);
					showModule($additionalInfoModule);
					passFocusToTab($additionalInfoModule);
				});
				$policies.on('click', function() {
					scrollToSection(this, policiesOffset);
					highlightTitle($policiesModule);
					showModule($policiesModule);
					passFocusToTab($policiesModule);
				});
			},
		});

	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
